// src/pages/Emulsifiers.js
import React from 'react';
import ProductCategoryTemplate from '../components/templet/ProductCategoryTemplate';
import image2 from '../assets/images/product/image-2.jpg';
import image3 from '../assets/images/product/image-3.jpg';
import image4 from '../assets/images/product/image-4.jpg';
import image5 from '../assets/images/product/image-5.jpg';
import image6 from '../assets/images/product/image-6.jpg';
import image7 from '../assets/images/product/image-7.jpg';
import image8 from '../assets/images/product/image-8.jpg';
import image9 from '../assets/images/product/image-9.jpg';
import emulsifier from '../assets/images/category/emulsifier.jpg';

const Emulsifiers = () => {
  const products = [
    {
      name: "Emulsifier Blends",
      category: "EMULSIFIER",
      description: "Advanced emulsifier blends that improve dough handling, enhance texture, and extend shelf-life. Our custom formulations combine multiple emulsifiers for optimal performance in various bakery applications.",
      features: [
        "Distilled Mono-di-glycerides (E471) : A multipurpose blend of emulsifiers (Distilled MGD + Others) - High, Well, SSL for multi-product uses that provides dough strengthening",
        "Lecithin Blends (E322 S/R/P/SF) : Soy, Rapeseed, Palm-based, or Sunflower-based lecithin—naturally sourced and highly functional",
        "Custom Cake Emul (DECL) : Specialized bakery emulsifier blend for optimum cake performance"
      ],
      image: "/assets/images/emulsifier-blends.jpg"
    },
    {
      name: "DATEM & Clean Alternatives",
      category: "EMULSIFIER",
      description: "Diacetyl Tartaric Acid Esters of Mono- and Diglycerides (DATEM) and clean-label alternatives. Powerful dough strengtheners that improve volume, crumb structure, and processing tolerance.",
      features: [
        "DATEM (E472e) : Exceptional dough strengthening and gas retention",
        "Clean Label DATEM: Natural alternatives for health-conscious formulations",
        "Improved dough stability and machinability during production",
        "Enhanced volume and uniform crumb structure in finished products"
      ],
      image: "/assets/images/datem.jpg"
    },
    {
      name: "Other Emulsifier Solutions",
      category: "EMULSIFIERS",
      description: "Specialized emulsifier systems for specific applications. From SSL for bread to PGMS for aeration, we have solutions for every bakery challenge.",
      features: [
        "Sodium Stearoyl Lactylate (SSL) : Improves loaf volume and crumb structure in yeasted breads",
        "Calcium Stearoyl Lactylate (CSL) : Enhances dough strength and shelf-life in bakery products",
        "PGMS (Polyglycerol Monostearate) : Excellent for aeration and volume improvement",
        "Custom Mono-Di Glycerides: Tailored emulsifier systems for specific needs"
      ],
      image: "/assets/images/other-emulsifiers.jpg"
    }
  ];

  const relatedCategories = [
    {
      title: "Bread Improvers & Dough Conditioners",
      description: "Boost volume and improve texture.",
      itemCount: 12,
      image: image2,
      link: "/products/bread-improvers"
    },
    {
      title: "Premixes & Concentrates",
      description: "Consistent results every time.",
      itemCount: 14,
      image: image3,
      link: "/products/premixes"
    },
    {
      title: "Shelf-Life Enhancers & Preservatives",
      description: "Keep products fresher longer.",
      itemCount: 10,
      image: image4,
      link: "/products/shelf-life"
    },
    {
      title: "Leavening Agents (Raising Agents)",
      description: "Perfect volume every time.",
      itemCount: 13,
      image: image5,
      link: "/products/leavening"
    },
    {
      title: "Specialty Enzymes",
      description: "Natural dough improvement.",
      itemCount: 17,
      image: image6,
      link: "/products/enzymes"
    },
    {
      title: "Other Ingredients: Starches, Gums, Flavors",
      description: "Complete ingredient solutions.",
      itemCount: 20,
      image: image7,
      link: "/products/other-ingredients"
    },
    {
      title: "Quality Assurance",
      description: "Guaranteed consistency.",
      itemCount: null,
      image: image8,
      link: "/quality"
    },
    {
      title: "View All",
      description: "Complete product range.",
      itemCount: null,
      image: image9,
      link: "/products"
    }
  ];

  return (
    <ProductCategoryTemplate
      title="Emulsifiers & Texture Improvers"
      description="Smoother texture, softer crumbs, longer shelf life—made effortless. Our advanced emulsifier systems help you achieve superior product quality while improving processing efficiency and extending freshness."
      heroImage={emulsifier}
      products={products}
      relatedCategories={relatedCategories}
    />
  );
};

export default Emulsifiers;